import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
    Box,
    Avatar,
    Grid,
    Card,
    CardContent,
    CardHeader,
    Hidden,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";
import { setSuccess, setWarning } from "../../reducers/appSlice";
import Alert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import BuscadorTema from "../../commons/BuscadorTema";
import CircularProgress from "@mui/material/CircularProgress";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import { useHistory } from "react-router-dom";
// icons

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import * as Yup from "yup";

// rutas de peticiones axios
import api from "../../service/api";

import MinimalPage from "../../layout/MinimalPage";

import { useParams } from "react-router-dom";

// estilos
import { styled } from "@mui/material/styles";



import { setError } from "../../reducers/appSlice";

import TextField from "@mui/material/TextField";

import { useFormik } from "formik";

const Row = styled(Grid)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));

const EditarTramite = (props) => {
    const dispatch = useDispatch();

    const location = useLocation();
    const { from } = location.state || { from: { pathname: "/" } };
    const history = useHistory();
    const [buscandoTema, setBuscandoTema] = useState(false);
    const [datos_tramite, setDatosTramite] = useState([]);
    const [cant_folios, setCantFolios] = useState(0);
    const [asuntoOriginal, setAsuntoOriginal] = useState("");
    const [codigTemaOriginal, setCodigTemaOriginal] = useState("");
    const [foliosOriginal, setFoliosOriginal] = useState("");
    const [asunto, setAsunto] = useState("");

    const [submitting, setSubmitting] = useState(false);

    const [filtro] = useState({
        tramiteId: useParams().tramiteId,
    });



    const leyendaTema =
        "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";


    const validationSchema = Yup.object().shape({
        codigoTema: Yup.number().required("Requerido"),
        tema: Yup.string().required("Requerido"),
        asunto: Yup.string().required("Requerido"),
        folios: Yup.number().required("Requerido"),

    });


    const formik = useFormik({
        initialValues: {
            asunto: asunto,
            folios: cant_folios,
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {

            //VEO SI EL TEMA O ASUNTO CAMBIARON 

            let generarCaratula = "N";
            let asunto = null;
            let folios = null;
            let temId = null;

            if (values.codigoTema !== codigTemaOriginal){
                generarCaratula = "T";
                temId = values.codigoTema;                
            }
            if (values.asunto !== asuntoOriginal){
                generarCaratula = "T";
                asunto = values.asunto;                
            }
            if (values.folios !== foliosOriginal){               
                folios = values.folios;                
            }

            api
                .editarTramite({
                    traId: filtro.tramiteId,
                    asunto: asunto,
                    folios: folios,
                    temId:temId,
                    generarCaratula,

                })
                .then((res) => {
                    dispatch(setSuccess("El trámite se editó con éxito"));
                    history.push("/bandeja_entrada/");
                    setSubmitting(true);
                })
                .catch((e) => {
                    console.log(e.response.data.detalle);
                    dispatch(setError(e.response.data.error));
                    setSubmitting(false);
                });
        },
        onReset: () => { },
    });

    const handleClose = () => {
        formik.handleReset();
    };
    // migas
    const breadcrumbs = [
        { nombre: "Inicio", ruta: "/" },
        {
            nombre:
                from.pathname === "/bandeja_entrada"
                    ? "Bandeja de entrada"
                    : "Edición",
            ruta: from.pathname,
        },
        { nombre: "Edición expediente", ruta: "" },
    ];

    const handleChangeFolios = (event) => {
        if (/^\d*$/.test(event.target.value)) {
            formik.setFieldValue(event.target.id, event.target.value);
        }
    };

    const handleTema = (tema = null) => {
        if (tema !== null) {
            formik.setFieldValue("codigoTema", tema.id);
            formik.setFieldValue("tema", tema.descTemaCompleto);

        } else {
            formik.setFieldValue("tema", "");

        }
    };

    const handleCodigo = (event) => {
        if (event.keyCode === 13 || event.keyCode === 9) {
            if (event.target.value !== "" && event.target.value !== null) {
                buscarTemaPorCodigo(event.target.value);
            }
        } else if (
            event.type === "blur" &&
            formik.values.tema === "" &&
            event.target.value !== "" &&
            event.target.value !== null
        ) {
            buscarTemaPorCodigo(event.target.value);
        }
    };

    const handleChangeCodigo = (event) => {
        if (formik.values.tema !== "" && formik.values.tema !== null) handleTema();

        if (/^\d*$/.test(event.target.value)) formik.setFieldValue("codigoTema", event.target.value);
    };

    const buscarTemaPorCodigo = (codigo) => {
        setBuscandoTema(true);
        api
            .buscarTema({
                id: codigo,
                descripcion: "",
                general: "T",
                digital: "T",
                activo: "S",
                alta: "S",
            })
            .then((res) => {
                if (res.data && res.data.length > 0) {
                    handleTema(res.data[0]);
                } else {
                    handleTema();
                    dispatch(setError("No se encontró tema"));
                }
            })
            .catch((e) => {
                handleTema();
                dispatch(setError("Error al buscar el tema"));
            })
            .finally(() => setBuscandoTema(false));
    };

    const buscarTramiteAmin = (filtro) => {
        api
            .verTramiteAdmin(filtro)
            .then((res) => {
                setDatosTramite(res.data.tramite);


                if (res.data.tramite.length > 0) {
                    if (res.data.tramite[0].cant_folios !== null) {
                        setCantFolios(res.data.tramite[0].cant_folios);
                    } else {
                        setCantFolios(0);
                    }

                    setAsunto(res.data.tramite[0].asunto);
                    setAsuntoOriginal(res.data.tramite[0].asunto);
                    setCodigTemaOriginal(res.data.tramite[0].codigoTema);
                    setFoliosOriginal(res.data.tramite[0].cant_folios);

                    formik.setFieldValue("tema", res.data.tramite[0].tema);
                    formik.setFieldValue("codigoTema", res.data.tramite[0].codigoTema);
                }




            })
            .catch((e) => {
                console.log(e);
                console.log("Error al cargar los datos");
            });
    };

    const reiniciarFormulario = () => {
        history.push("/bandeja_entrada/");
    };

    useEffect(() => {
        buscarTramiteAmin(filtro);

    }, []);

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`scrollable-force-tabpanel-${index}`}
                aria-labelledby={`scrollable-force-tab-${index}`}
                {...other}

            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    const Div = styled("div")(({ theme }) => ({
        marginBottom: 15,
    }));

    const Alerta = styled(Alert)(({ theme }) => ({
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
            marginBottom: 15,
            color: "#799f4f",
        },
    }));


    function render() {
        let panels;
        // si no tiene N° de expediente, mustra tramite y fecha de tramite
        if (datos_tramite[0].nro_expediente == null) {
            panels = (
                <Div>
                    <Hidden mdDown>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Nº de trámite interno
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Fecha de inicio</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Hidden>
                    <Hidden mdUp>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Nº de trámite interno
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Fecha de inicio</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Div>
            );
            // si tiene N° de expediente, pero las fechas de expediente y tramite son iguales
        } else if (
            datos_tramite[0].nro_expediente != null &&
            datos_tramite[0].fecha_tramite === datos_tramite[0].fecha_expediente
        ) {
            panels = (
                <Div>
                    <Hidden lgDown>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ p: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Nº de expediente</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Fecha de expediente
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Hidden>

                    <Hidden lgUp>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Nº de expediente</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Fecha de expediente
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Div>
            );
            // si tiene N° de expediente con fecha distinta al tramite
        } else {
            panels = (
                <Div>
                    {/* Mostramos cuando la pantalla va de 1280px a 1920px o mas grabde */}
                    <Hidden mdDown>
                        <Grid container spacing={3}>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Nº de trámite interno
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Fecha de inicio</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Nº de expediente</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Fecha de expediente
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Hidden>
                    {/* Mostramos cuando la pantalla va de 0px a 1280px */}
                    <Hidden mdUp>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Nº de trámite interno
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_tramite}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Fecha de inicio</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <VpnKeyIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].nro_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">Nº de expediente</Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Card sx={{ padding: 1 }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                aria-label="recipe"
                                                sx={{ backgroundColor: "#799F4F" }}
                                            >
                                                <CalendarTodayIcon />
                                            </Avatar>
                                        }
                                        disabledTypography
                                        title={
                                            <Typography variant="titulo" component="p">
                                                {datos_tramite[0].fecha_expediente}
                                            </Typography>
                                        }
                                        subheader={
                                            <Typography variant="cuerpo">
                                                Fecha de expediente
                      </Typography>
                                        }
                                        sx={{ height: "80px" }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Div>
            );
        }
        // retornamos lo creado
        return panels;
    }



    return (
        <MinimalPage breadcrumbs={breadcrumbs} disableCheckAuth>
            <Card>
                <CardContent>
                    {/* cards */}
                    {datos_tramite.map((itemTramite) => (
                        <Div>
                            {render()}
                            <Grid container spacing={2}>
                                <Grid item xs={10}></Grid>

                            </Grid>
                        </Div>
                    ))
                    }

                    <form
                        id="editar"
                        name="editar"
                        onSubmit={formik.handleSubmit}
                        onReset={formik.handleReset}
                        noValidate
                        autoComplete="off"
                    >

                        <Row container spacing={2}>
                            <Grid item lg={2} xs={12}>
                                <TextField
                                    id="codigoTema"
                                    name="codigoTema"
                                    label="Código de tema"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    inputProps={{ maxLength: 8 }}
                                    value={formik.values.codigoTema}
                                    onChange={handleChangeCodigo}
                                    onKeyDown={handleCodigo}
                                    onBlur={handleCodigo}
                                    error={
                                        formik.touched.codigoTema && Boolean(formik.errors.codigoTema)
                                    }
                                    helperText={formik.touched.codigoTema && formik.errors.codigoTema}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <Typography
                                    variant="aclaracion"
                                    sx={{
                                        display: {
                                            xs: "inline",
                                            sm: "inline",
                                            md: "inline",
                                            lg: "none",
                                        },
                                    }}
                                >
                                    {leyendaTema}
                                </Typography>
                            </Grid>
                            <Grid item lg={10} xs={12}>
                                <Box display="flex" flexDirection="row">
                                    <TextField
                                        id="tema"
                                        name="tema"
                                        label="Tema"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={formik.values.tema}
                                        onChange={formik.handleChange}
                                        error={formik.touched.tema && Boolean(formik.errors.tema)}
                                        helperText={formik.touched.tema && formik.errors.tema}
                                        InputLabelProps={{ shrink: true }}
                                        disabled
                                    />
                                    {buscandoTema ? (
                                        <CircularProgress
                                            color="primary"
                                            size={20}
                                            sx={{ margin: 1 }}
                                        />
                                    ) : (
                                            <BuscadorTema resultado={handleTema} activo={"S"} alta={"S"} />
                                        )}
                                </Box>
                            </Grid>
                            <Grid container>
                                <Typography
                                    variant="aclaracion"
                                    sx={{
                                        ml: 2,
                                        display: { xs: "none", sm: "none", md: "none", lg: "inline" },
                                    }}
                                >
                                    {leyendaTema}
                                </Typography>
                            </Grid>
                        </Row>


                        <Grid item lg={12} xs={12}>
                            <TextField
                                id="asunto"
                                name="asunto"
                                label="Asunto"
                                variant="outlined"
                                size="small"
                                multiline
                                rows={3}
                                fullWidth
                                inputProps={{ maxLength: 1000 }}
                                value={formik.values.asunto}
                                onChange={formik.handleChange}
                                error={formik.touched.asunto && Boolean(formik.errors.asunto)}
                                helperText={(formik.touched.asunto && formik.errors.asunto) || "Máximo 1.000 caracteres"}

                            />
                            <br /><br />
                        </Grid>

                        <Grid item lg={1} xs={12}>
                            <TextField
                                type="text"
                                id="folios"
                                name="folios"
                                label="Folios"
                                variant="outlined"
                                size="small"
                                fullWidth
                                inputProps={{ maxLength: 5 }}
                                value={formik.values.folios}
                                onChange={handleChangeFolios}
                                error={formik.touched.folios && Boolean(formik.errors.folios)}
                                helperText={formik.touched.folios && formik.errors.folios}
                            />
                        </Grid>

                        <Grid container spacing={1} sx={{ pl: 2, pr: 1, paddingLeft: 1 }}>
                            <Grid item lg={12} xs={12} align="right">
                                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                                    <Button
                                        variant="plata"
                                        onClick={() => reiniciarFormulario()}
                                        sx={{ m: 1 }}
                                        endIcon={<ClearIcon />}
                                    >
                                        Cancelar
                </Button>{" "}
                                    <Button
                                        variant="verde"
                                        type="submit"
                                        sx={{ m: 1 }}
                                        endIcon={<DoneOutlineRounded />}
                                    >
                                        {submitting ? "Confirmando..." : "Confirmar"}
                                    </Button>
                                </Box>
                                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                                    <IconButton color="primary" onClick={handleClose} title="Cancelar">
                                        <ClearIcon />
                                    </IconButton>{" "}
                                    <IconButton
                                        color="primary"
                                        type="submit"
                                        disabled={submitting}
                                        title="Confirmar"
                                    >
                                        <DoneOutlineRounded />
                                    </IconButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </form >

                </CardContent>
            </Card>
        </MinimalPage >

    );

};



export default EditarTramite;
